module.exports = __webpack_public_path__ + "img/img-cardnews-01-3.281ceaa7.png";